import cardImg from "../../../../../Assets/Images/card-img.png";
const MatrixData = ({ stats }) => {
  return (
    <div className="user-data shadow card border-0 mx-2">
      <div className="row">
        <div className="col-6 col-md-3 col-lg-3">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.totalStudents}</p>
              <p className="text-para m-0">Total Students</p>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3 col-lg-3">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.allSubmittedStudents}</p>
              <p className="text-para m-0">Students with all submissions</p>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3 col-lg-3">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.noSubmissionStudents}</p>
              <p className="text-para m-0">Students with no submissions</p>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3 col-lg-3">
          <div className="card-text data-column">
            <div className="card-img img-size">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.submittedStudents}</p>
              <p className="text-para m-0">Students with at-least 1 submission</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixData;
